query GetSageGiftAccountDifferenceCounts {
  sageGiftAccountDifferenceCounts {
    openCount
    ignoredCount
    acceptedCount
    resolvedCount
    openByKind {
      kind
      count
    }
  }
}
